export enum CompletenessStatus {
  None,
  Active,
  Completed,
}
